import React, { Component } from "react";
import ListPanel from "./list-panel/ListPanel";
import ContentPanel from "./ContentPanelWithStore";
import InfoPanel from "./InfoPanelWithStore";

export default class ModuleCaseHistory extends Component {
  render() {
    return [
      <ListPanel key="list" />,
      <ContentPanel key="content" />,
      <InfoPanel key="info" />
    ];
  }
}



// WEBPACK FOOTER //
// ./src/module-case-history/ModuleCaseHistory.js